'use strict';

import Vue from 'vue';
import wx from 'weixin-js-sdk'

function wxConfig(url) {
  return Vue.http.post('index/weixinConfig', {
    url: url||location.href
  }).then(data => {
    // console.log(data)
    if (data.data.code !== 0) {
      return Promise.reject(new Error(data.error.message));
    };
    return data.data.value;
  }).then(data => {
    // console.log(data)
    return new Promise((resolve, reject) => {
      wx.config({
        beta:true,//开启内测接口调用，注入wx.invoke方法
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名，见附录1
        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQZone", "onMenuShareQQ", "scanQRCode", "closeWindow", 'updateAppMessageShareData', 'updateTimelineShareData', 'configWXDeviceWiFi']// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function(data){
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        // console.log('wx ready', data);
        sessionStorage.setItem('wxCongigStatus', 1);
        resolve();
      });
    })
  });
}


// 分享hash处理，检测分享结果, 在需要分享的页面调用该函数，参数传入让被分享者看到的页面地址，可包含#？
function wxShare(link, title, desc, icon, path, callback) {
  let replaceLink = ''
  if (link.indexOf('#') > -1) {
    if (link.indexOf('?') > -1) {
      replaceLink = link.replace('?', '&').replace('/#/', '?hash_path=')
    } else {
      replaceLink = link.replace('/#/', '?hash_path=')
    }
  } else {
    replaceLink = link
  }

  const shareOptions = {
    title: title + '-新锐台球俱乐部' || '新锐台球俱乐部',
    imgUrl: path || `https://www.buole.com/assets/v2/img/${ icon || 'buole_icon.jpg'}`,
    desc: desc || '新锐台球俱乐部',
    link: replaceLink
  }

  wxConfig().then(() => {
    setShareData(shareOptions);
  }).then(() => {
    if (callback) {
      callback();
    }
  })
}

// 微信QQ分享配置函数
function setShareData(shareOptions) {
  let ua = navigator.userAgent;
  // alert(ua)
  if(ua.match(/MicroMessenger/i)=="MicroMessenger"){
    var wechatInfo = ua.match(/MicroMessenger\/([\d\.]+)/i);
    if ( wechatInfo[1] < '6.7.2' ) {
      // 分享到朋友圈
      console.log('配置低版本')
      wx.onMenuShareTimeline({
        title: shareOptions.title,
        link: shareOptions.link,
        imgUrl: shareOptions.imgUrl,
        success: () => {
        }
      })
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: shareOptions.title,
        desc: shareOptions.desc,
        link: shareOptions.link,
        imgUrl: shareOptions.imgUrl,
        success: () => {
        }
      })
      // 分享到qq
      wx.onMenuShareQQ({
        title: shareOptions.title,
        desc: shareOptions.desc,
        link: shareOptions.link,
        imgUrl: shareOptions.imgUrl,
        success: () => {
          console.log('分享成功')
        }
      })
    } else {
      // 微信客户端6.7.2及JSSDK 1.4.0以上版本
      console.log('配置高版本')
      // 分享给朋友或者qq
      wx.updateAppMessageShareData(shareOptions, function(res) {// 这里是回调函数
        console.log(res);
      });
      // 分享到朋友圈或qq空间
      wx.updateTimelineShareData(shareOptions, function(res) {//这里是回调函数
        console.log(res);
      });
    }
  }
}

// 截取分享参数，处理hash
function getShareParams() {
  console.log('截取分享参数，处理hash')
  let pageUrl = location.href;
  if (pageUrl.indexOf('hash_path=') >= 0) {
    sessionStorage.removeItem('showHomeToTest')
    pageUrl = pageUrl.split('#')[0]
    let url = pageUrl.replace('?hash_path=', '#/')
    location.href = url.replace('&', '?')
    return;
  }
}

/**
 * 将微信和QQ分享直接配置成一个函数
 * @param {分享标题} title
 * @param {分享图片} imgUrl
 * @param {分享介绍} desc
 * @param {分享链接} link
 */
// function configWxShare(title, imgUrl, desc, link) {
//   config().then(data => {
//     // 分享到朋友圈
//     wx.onMenuShareTimeline({
//       title: title + '-新锐台球',
//       link: link,
//       imgUrl: imgUrl
//     })
//      // 分享给朋友
//     wx.onMenuShareAppMessage({
//       title: title + '-新锐台球',
//       desc: desc || '',
//       link: link,
//       imgUrl: imgUrl,
//     })
//     // 分享到qq
//     wx.onMenuShareQQ({
//       title: title + '-新锐台球',
//       desc: desc || "",
//       link: link,
//       imgUrl: imgUrl
//     })
//   })
// }

/**
 * 去微信授权
 * @param {回调地址} redirect
 * @param {state} state
 */
function wxOAuthUrl(redirect, state) {
  Vue.http.post('index/weixinConfig', location.href).then(res => {
    console.log(res)
    if (res.data.code !== 0) {
      console.error(res.data.message);
      return;
    }
    let appId = res.data.value.appId;
    // let appId = 'wx65e371fb9ae91702' // 测试
    location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
    // pc 扫码登录
    // location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${redirect}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`
  })
}

export default {
  // config: config,
  // configWxShare: configWxShare,
  wxOAuthUrl: wxOAuthUrl,
  wxConfig,
  wxShare,
  getShareParams
}



// WEBPACK FOOTER //
// ./src/assets/scripts/wechat.js